import { t } from "i18next";

export const emptyFeatureRow = () => ({
    feature: {
        name: "",
        label: "",
        value: "",
        language: "fa",
        feature_type: 1,
        feature_level: 2,
    },
    mandatory: false,
});

export const featuresFromApi = (rows) =>
    (Array.isArray(rows) ? rows : []).map((row) => ({
        feature: {
            label: row.name,
            value: (row.name || "").toLowerCase(),
            id: row.feature,
            language: row.language,
        },
        mandatory: Boolean(row.mandatory),
    }));

export const featuresToPayload = (rows) =>
    (rows || [])
        .map((row) => {
            const name = (
                row.feature?.name ||
                row.feature?.label ||
                ""
            ).trim();
            if (row.feature?.id) {
                return {
                    feature: row.feature.id,
                    mandatory: Boolean(row.mandatory),
                };
            }
            if (name.length < 2) return null;
            return {
                mandatory: Boolean(row.mandatory),
                feature: {
                    name,
                    language: row.feature?.language || "fa",
                    feature_type: row.feature?.feature_type || 1,
                    feature_level: 2,
                },
            };
        })
        .filter(Boolean);

export const validateFeatureRows = (rows) => {
    const errors = [];
    (rows || []).forEach((row, index) => {
        if (row.feature?.id) {
            errors[index] = undefined;
            return;
        }
        const name = (row.feature?.name || row.feature?.label || "").trim();
        errors[index] =
            name.length > 0 && name.length < 2
                ? t("form.feature.length.err")
                : undefined;
    });
    return errors;
};
